import { z } from 'zod';

import { savedDocumentAttachment, zodDate, zodStringRequired } from '@/shared/lib/validations';

import { TODAY } from '@/helpers/dates';

export const expertResearchDataSchema = z.object({
  expertOrganization: zodStringRequired,
  examinationDate: zodDate({ max: TODAY }),
  expertResearch: savedDocumentAttachment,
});
